<template>
  <section class="local-lm-orders-title-mtop">
    <div class="lm-header">
      <h3
        v-if="orders && orders.length === 0 && hasSummited"
        class="subtitle is-5"
        v-t="$t('Orders.noResults')"
      />
      <h3
        v-if="orders && orders.length > 0"
        class="subtitle is-5"
        v-t="$t('Orders.results')"
      />
    </div>
    <div
      v-if="orders && orders.length"
    >
      <div
       class="container local-lm-order-btns"
      >
        <order-table-filter />
        <div
          v-if="!options"
        >
          <b-button
            icon-right="file-download-outline"
            class="lm-default-btn--no-outline local-lm-xs-marginTop"
            @click.prevent="downloadExcel"
          >
            {{ $t('Orders.exportExcelFile') }}
          </b-button>
        </div>
      </div>
      <b-table
        ref="table"
        :data="orders"
        :paginated="isPaginated"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :checkbox-position="checkboxPosition"
        :opened-detailed="defaultOpenedDetails"
        :checked-rows.sync="checkedRows"
        :total="totalCount"
        :current-page.sync="currentPage"
        backend-pagination
        per-page="13"
        detail-key="id"
        checkable
        detailed
        hoverable
        narrowed
        class="local-lm-orders-table"
        @click="(row) => closeAllOtherDetails(row)"
      >
        <b-table-column
          field="id"
          width="150"
          :label="$t('Orders.labelNumOrder')"
          v-slot="props"
        >
          <div>
            <p
              v-if="options !== 'edf' && options !== 'edd'"
            >
              <span
                class="local-lm-orders-label"
                v-t="'Orders.orderId'"
              >
              </span>
              {{ props.row.customerOrderCode }}
            </p>
            <p
              v-if="options === 'edf' || options === 'edd'"
            >
              <span
                class="local-lm-orders-label"
                v-t="'Orders.orderId'"
              >
              </span>
              {{ props.row.supplierOrderCode }}
            </p>
            <p
              v-if="options === 'edf' || options === 'edd'"
            >
              [ {{ props.row.customerOrderCode }} ]
            </p>
            <p
              v-if="!options"
            >
              <span
                class="local-lm-orders-label"
                v-t="'Orders.deliveryDate'"
              >
              </span>
              {{ props.row.deliveryDate | stripHour }}
            </p>
            <p
              v-if="options === 'delivery'"
            >
              <span
                class="local-lm-orders-label"
                v-t="'Orders.alreadyDeliveryDate'"
              >
              </span>
              {{ props.row.confirmedDeliveryDate }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          field="deliveryDate"
          width="180"
          :label="$t('Orders.labelPackage')"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.numberVolumes'"
              />
              <volumes-tag
                :volumes="props.row.volumeTotal || 0"
                :pallets="props.row.palletTotal || 0"
                :equivalents="props.row.palletEquivalentNumber || 0"
                :normalPalletEquivalent="props.row.palletEquivalentForPartner || 0"
              />
            </p>
          </div>
        </b-table-column>
        <b-table-column
          width="250"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.labelWeight'"
              />
              <span
                v-html="$t('Orders.volumeWeight', { weight: props.row.weight, volume: props.row.volume })"
              />
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.type'"
              >
              </span>
              {{ props.row.deliveryType }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          width="200"
          :label="$t('Orders.labelUser')"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.customerName'"
              >
              </span>
              {{ props.row.customerLastName }}, {{ props.row.customerFirstName }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.customerPhone'"
              >
              </span>
              {{ props.row.customerPhoneNumber }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          width="200"
          v-slot="props"
        >
          <div>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.postalCode'"
              >
              </span>
              {{ props.row.deliveryPostalCode }}, {{ props.row.deliveryTown }}
            </p>
            <p>
              <span
                class="local-lm-orders-label"
                v-t="'Orders.obs'"
              >
              </span>
              {{ props.row.stateOrder }}
            </p>
          </div>
        </b-table-column>
        <b-table-column
          v-if="options === 'delivery'"
          field="props.row.customerOrderCode"
          width="30"
          v-slot="props"
        >
          <span>
            <b-button
              icon-right="sticker-plus-outline"
              class="local-lm-btn-row"
              @click.prevent="openModal([ ...props.row ], actions.showUploadPod)"
            />
          </span>
        </b-table-column>
        <b-table-column
          field="props.row.customerOrderCode"
          width="30"
          v-slot="props"
        >
          <span>
            <mail-box
              v-bind="props.row"
            />
          </span>
        </b-table-column>
        <b-table-column
          v-if="!options || options === 'edf' || options === 'edd'"
          field="props.row.customerOrderCode"
          width="30"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp1')"
              type="is-dark"
            >
              <b-button
                icon-right="truck"
                class="local-lm-btn-header"
                @click.prevent="openModal(checkedRows, actions.regist)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="truck"
                class="local-lm-btn-row"
                @click.prevent="openModal([ ...props.row ], actions.regist, props.row.deliveryDate)"
              />
            </span>
          </template>
        </b-table-column>
        <b-table-column
          v-if="!options || (options !== 'edf' && options !== 'delivery') || options === 'edd'"
          field="props.row.customerOrderCode"
          width="30"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp2')"
              type="is-dark"
            >
              <b-button
                icon-right="calendar"
                class="local-lm-btn-header"
                @click="openModal(checkedRows, actions.reschedule)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="calendar"
                class="local-lm-btn-row"
                @click="openModal([ ...props.row ], actions.reschedule, props.row.deliveryDate)"
              />
            </span>
          </template>
        </b-table-column>
        <b-table-column
          v-if="!options || (options !== 'edf' && options !== 'delivery') || options === 'edd'"
          field="props.row.customerOrderCode"
          width="30"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp3')"
              type="is-dark"
            >
              <b-button
                icon-right="clock-outline"
                class="local-lm-btn-header"
                @click="openModal(checkedRows, actions.schedule)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="clock-outline"
                class="local-lm-btn-row"
                @click="openModal([ ...props.row ], actions.schedule, props.row.deliveryDate)"
              />
            </span>
          </template>
        </b-table-column>
        <b-table-column
          v-if="options === 'edf'"
          field="props.row.customerOrderCode"
          width="30"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp8')"
              type="is-dark"
            >
              <b-button
                icon-right="calendar-clock"
                class="local-lm-btn-header"
                @click="openModal(checkedRows, actions.rescheduleDateTime)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="calendar-clock"
                class="local-lm-btn-row"
                @click="openModal([ ...props.row ], actions.rescheduleDateTime, props.row.supplierExpectedCollectionDate)"
              />
            </span>
          </template>
        </b-table-column>
        <b-table-column
          v-if="options === 'edf' || options === 'edd'"
          field="props.row.customerOrderCode"
          width="30"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp7')"
              type="is-dark"
            >
              <b-button
                icon-right="check-outline"
                class="local-lm-btn-header"
                @click="openModal(checkedRows, actions.collected)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="check-outline"
                class="local-lm-btn-row"
                @click="openModal([ ...props.row ], actions.collected, props.row.deliveryDate)"
              />
            </span>
          </template>
        </b-table-column>
        <b-table-column
          v-if="!options"
          field="props.row.customerOrderCode"
          width="30"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp4')"
              type="is-dark"
            >
              <b-button
                icon-right="flag-outline"
                class="local-lm-btn-header"
                @click="openModal(checkedRows, actions.delivered)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="flag-outline"
                class="local-lm-btn-row"
                @click="openModal([ ...props.row ], actions.delivered, props.row.deliveryDate)"
              />
            </span>
          </template>
        </b-table-column>
        <b-table-column
          v-if="!options || options === 'edf' || options === 'edd'"
          field="props.row.customerOrderCode"
          width="30"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp5')"
              type="is-dark"
              position="is-left"
            >
              <b-button
                icon-right="alert-outline"
                class="local-lm-btn-header"
                @click="openModal(checkedRows, actions.incidence)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="alert-outline"
                class="local-lm-btn-row"
                @click="openModal([ ...props.row ], actions.incidence, props.row.deliveryDate)"
              />
            </span>
          </template>
        </b-table-column>
        <b-table-column
          v-if="options === 'delivery'"
          field="props.row.customerOrderCode"
          width="30"
        >
          <template #header="">
            <b-tooltip
              :label="$t('Orders.tooltipOp6')"
              type="is-dark"
              position="is-left"
            >
              <b-button
                icon-right="history"
                class="local-lm-btn-header"
                @click="openModal(checkedRows, actions.restore, props.row.confirmedDeliveryDate)"
              />
            </b-tooltip>
          </template>
          <template v-slot="props">
            <span>
              <b-button
                icon-right="history"
                class="local-lm-btn-row"
                @click="openModal([ ...props.row ], actions.restore, props.row.confirmedDeliveryDate)"
              />
            </span>
          </template>
        </b-table-column>

        <template #detail="props">
          <section>
            <div class="columns local-lm-columns">
              <div class="column is-1 lm-default-bold">
                {{ $t('Orders.NumOrder', { value: props.row.customerOrderCode }) }}
              </div>
              <div class="column is-1">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.numVolumes'"
                  />
                  <div
                    v-text="props.row.volumeTotal"
                  />
                </div>
              </div>
              <div class="column is-1">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.numPallet'"
                  />
                  <div
                    v-text="props.row.palletTotal"
                  />
                </div>
              </div>
              <div class="column is-2">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.equivalentNumberPallet'"
                  />
                  <div
                    v-text="props.row.palletEquivalentNumber"
                  />
                </div>
              </div>
              <div class="column is-2">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.normalEquivalentPallet'"
                  />
                  <div
                    v-text="props.row.palletEquivalentForPartner"
                  />
                </div>
              </div>
              <div class="column is-2">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.labelWeight'"
                  />
                  <div
                    v-html="$t('Orders.volumeWeight', { weight: props.row.weight, volume: props.row.volume })"
                  />
                </div>
              </div>
              <div class="column is-3">
                <div
                  v-if="!props.row.collectPoint.collectPointName"
                  class="local-lm-cell-details"
                >
                  <label
                    v-t="'Orders.store'"
                  />
                  <div
                    v-text="props.row.store.name"
                  />
                </div>
                <div
                  v-if="props.row.collectPoint.collectPointName"
                  class="local-lm-cell-details"
                >
                  <label
                    v-t="'Orders.collectPoint'"
                  />
                  <div
                    v-text="props.row.collectPoint.collectPointName"
                  />
                </div>
              </div>
            </div>
            <div class="columns local-lm-columns">
              <div class="column is-1 lm-default-bold">
                {{ $t('Orders.delivery', { date: stripHour(props.row.deliveryDate) }) }}
              </div>
              <div class="column is-3">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.address'"
                  />
                  <div
                    v-text="props.row.deliveryAddress"
                  />
                </div>
              </div>
              <div class="column is-1">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.pCode'"
                  />
                  <div
                    v-t="props.row.deliveryPostalCode"
                  />
                </div>
              </div>
              <div class="column is-2">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.city'"
                  />
                  <div
                    v-t="props.row.deliveryTown"
                  />
                </div>
              </div>
              <div class="column is-2">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.deliveryType'"
                  />
                  <div
                    v-text="props.row.deliveryType"
                  />
                </div>
              </div>
              <div class="column is-1">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.helper'"
                  />
                  <div
                    v-text="props.row.extraHelper"
                  />
                </div>
              </div>
              <div class="column is-1">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.deliveryPeriod'"
                  />
                  <div
                    v-if="props.row.deliveryPeriod"
                    v-t="_applySomeExceptions(props.row)"
                  />
                </div>
              </div>
              <div class="column is-1">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.plate'"
                  />
                  <div
                    v-if="props.row.vehicleRegistration"
                    v-text="props.row.vehicleRegistration"
                  />
                </div>
              </div>
            </div>
            <div class="columns local-lm-columns">
              <div
                v-if="options === 'edf'"
                class="column is-1 lm-default-bold"
              >
                {{ $t('Orders.previewDeliveryDate', { date: stripHour(props.row.supplierExpectedCollectionDate) }) }}
              </div>
              <div
                v-else
                class="column is-1 lm-default-bold"
              />
              <div class="column is-2">
                <div
                  v-if="options === 'edf'"
                  class="local-lm-cell-details"
                >
                  <label
                    v-t="'Orders.scheduleCollection'"
                  />
                  <div
                    v-if="props.row.partnerExpectedCollectionDate"
                    v-t="`${stripHour(props.row.partnerExpectedCollectionDate)}`"
                  />
                </div>
                <div
                  v-else
                  class="local-lm-cell-details"
                >
                  <label
                    v-t="'Orders.collection'"
                  />
                  <div
                    v-if="props.row.conditionalYesOrNo"
                    v-t="`Orders.${props.row.conditionalYesOrNo}`"
                  />
                </div>
              </div>
              <div class="column is-9">
                <div
                  v-if="options === 'edf'"
                  class="local-lm-cell-details"
                >
                  <label
                    v-t="'Orders.scheduleInformation'"
                  />
                  <div
                    v-text="props.row.collectInformation"
                  />
                </div>
                <div
                  v-else
                  class="local-lm-cell-details"
                >
                  <label
                    v-t="'Orders.collectionInformation'"
                  />
                  <div
                    v-text="props.row.collectInformation"
                  />
                </div>
              </div>
            </div>
            <div class="columns local-lm-columns">
              <div
                class="column is-1 lm-default-bold"
                v-t="'Orders.clientDetails'"
              />
              <div class="column is-3">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.userName'"
                  />
                  <div>{{ props.row.customerLastName }}, {{ props.row.customerFirstName }}</div>
                </div>
              </div>
              <div class="column is-3">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.email'"
                  />
                  <div
                    v-t="props.row.customerMail"
                  />
                </div>
              </div>
              <div class="column is-1">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.phone'"
                  />
                  <div
                    v-t="props.row.customerPhoneNumber"
                  />
                </div>
              </div>
              <div class="column is-4">
                <div class="local-lm-cell-details">
                  <label
                    v-t="'Orders.observations'"
                  />
                  <div></div>
                </div>
              </div>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { mixin } from '@/mixins'
import MailBox from '@/components/MailBox'
import OrderTableFilter from '@/components/filters/OrderTableFilter'
import VolumesTag from '@/components/VolumesTag'

export default {
  name: 'Orders',
  props: ['options'],
  mixins: [
    mixin.notifications,
    mixin.dates
  ],
  computed: {
    ...mapGetters('orders', [
      'orders',
      'actions'
    ]),
    setActions () {
      return this.actions
    },
    totalCount () {
      return this.$store.getters['orders/totalCount']
    },
    currentPage: {
      get () {
        return this.$store.getters['filters/currentPage']
      },
      set (newVal) {
        this.$eventBus.$emit('onPageChange', newVal)
      }
    }
  },
  data () {
    return {
      hasSummited: false,
      hasData: false,
      checkboxPosition: 'left',
      isPaginated: true,
      isPaginationSimple: true,
      paginationPosition: 'top',
      defaultOpenedDetails: [],
      checkedRows: [],
      shouldOpen: true
    }
  },
  components: {
    OrderTableFilter,
    MailBox,
    VolumesTag
  },
  async mounted () {
    const filters = await this.$store.getters['filters/filtersSelected']
    await this.$store.dispatch('user/getVehicles')

    const payload = {
      filters,
      options: this.options || ''
    }
    const ok = await this.$store.dispatch('orders/getOrders', payload)
    if (!ok.level) return this.wrong(this.$t(ok.errorText))

    this.hasSummited = true

    this.$eventBus.$on('emptyOrders', () => {
      this.hasSummited = true
      this.hasData = true
    })

    this.$eventBus.$on('orders', async () => {
      this.checkedRows = []
      this.hasSummited = false
    })
  },
  methods: {
    closeAllOtherDetails (row) {
      if (!this.defaultOpenedDetails[0] || this.defaultOpenedDetails[0] === row.id) {
        if (this.shouldOpen) this.$refs.table.toggleDetails(row)
        this.shouldOpen = true
        return
      }

      if (this.defaultOpenedDetails[0] || this.defaultOpenedDetails[0] !== row.id) this.defaultOpenedDetails = [row.id]
    },
    async openModal (orders, type, date = '') {
      this.shouldOpen = false

      const data = {
        orders,
        type,
        date
      }

      switch (type) {
        case 'RESCHEDULE_DATE':
          this.$store.dispatch('filters/getReschedulesFilters')
          break
        case 'INCIDENCE':
          this.$store.dispatch('filters/getIncidentsFilters')
          break
        case 'SCHEDULE_PERIOD':
        case 'RESCHEDULE_DATE_TIME':
          this.$store.dispatch('filters/getSchedulesFilters')
          break
        case 'VEHICLE_REGISTRATION':
          this.$store.dispatch('user/getVehicles')
          break
        case 'SHOW_UPLOAD_POD':
        case 'DELIVERED':
          this.$store.dispatch('loading/start')

          const ordersIDs = orders.map(order => {
            const { id, customerOrderCode } = order

            return {
              id,
              customerOrderCode
            }
          })

          await this.$store.dispatch('filters/getListPods', ordersIDs)
          this.$store.dispatch('loading/stop')
          break
      }

      this.$store.dispatch('modal/launchModalWithData', data)
    },
    async downloadExcel () {
      const filters = await this.$store.getters['filters/filtersSelected']

      const file = await this.$store.dispatch('orders/download', filters)
      if (!file.level) this.wrong(this.$t('Errors.somethingWrong'))
    },
    _applySomeExceptions ({ deliveryPeriod }) {
      // ! MOVIMENT-1338 apply this exception until these slots was deleted from the system
      const exceptions = ['MORNING', 'AFTERNOON']

      const arrStrings = deliveryPeriod
        .split(' ')
        .map(item => item.trim())

      const onlyDescriptionString = arrStrings
        .slice(0, arrStrings.length - 3)
        .join(' ')

      const applyCorrectString = (exceptions.includes(onlyDescriptionString)) ? this.$t(`Orders.${onlyDescriptionString}`) : onlyDescriptionString.toUpperCase()
      return `${applyCorrectString}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Orders.vue